export default {
    home_page_title: "アカウント情報",
    security_page_title: "安全セーター",
    security_setting_page_title: "安全セーター",
    security_phone_label: "携帯番号",
    security_email_label: "メルアド",
    security_question_label: "セキュリティクエスチョン",
    security_unset_text: "未設定",
    security_setted_text: "Set",
    security_question_options: [
        "お母さんのお名前は？",
        "奥さん・ご主人のお名前は？",
        "お父さんのお名前は？",
        "ご出席番号・社員番号は？",
        "ご親友のお名前は？",
        "一番大きい影響が与えられた人のお名前は？"
    ],
    password_lost_page_title: "パスワードを取り戻す",
    password_reset_page_title: "パスワードリセット",
    password_lost_account_placeholder: "パスワードが忘却されたアカウントを入力",
    empty_lost_account_tips: "ユーザ名を必ず入力すること",
    iscorrect_lost_account_tips: "User does not exist",
    password_reset_new_placeholder: "新しいパスワード",
    password_reset_confirm_placeholder: "パスワードを確認する",
    password_verify_page_title: "身分検証",
    phone_verify_page_title: "身分検証",
    email_verify_page_title: "身分検証",
    question_verify_page_title: "身分検証",
    phone_reset_page_title: "携帯番号",
    email_reset_page_title: "メルアド",
    question_reset_page_title: "セキュリティクエスチョン",
    phone_binding_text: "連携した携帯番号",
    email_binding_text: "連携したメールアドレス",
    verification_code_text: "検証コード",
    resend_text: "もう一度送信する",
    empty_phone_number_tips: "携帯番号入力",
    iscorrect_phone_number_tips: "Please enter a valid phone number",
    empty_verification_code_tips: "検証コード入力",
    iscorrect_verification_code_tips: "検証コードエラ",
    password_placeholder: "パスワード",
    empty_password_tips: "パスワード入力",
    iscorrect_password_tips: "パスワードは正しくないです",
    mismatched_rule_password_tips:
        "パスワードには&、#と空白を使用しないてください",
    different_confirm_password_tips: "パスワードが一致していません",
    empty_email_tips: "メールアドレスを入力してください",
    iscorrect_email_tips: "メールアドレスは正しくないです",
    answer_placeholder: "回答",
    empty_question_tips: "Choose a security question",
    empty_answer_tips: "Give your answer here",
    iscorrect_answer_tips: "Wrong answer",
    next_step_text: "次へ",
    submit_text: "Submit",
    submit_success_tips: "Success",
    submit_error_tips: "Operation failed, please try again",
    get_data_fail_tips: "ネット障害です。後でリトライしてください",
    use_other_verification_type_text: "他の検証方法",
    custom_support_notice:
        "当アカウントはセキュリティ設定がありません。PCで下記のリンクをオープンして申請することができます。" +
        process.env.VUE_APP_ORIGIN_PROFILE
};
